import { useBusinessContext } from '@root/context'
import {
  getDefaultReferralRedeemBusinessSlug,
  getReferralRedeemEligibleBusinesses
} from '@utils/referralRedeemEligibleBusinesses'
import { IBusiness, useBusinesses, useCurrentUser } from '@query'
import { useEffect, useMemo, useState } from 'react'

export const useReferralRedeemEligibleBusinesses = () => {
  const { slug: contextSlug } = useBusinessContext()
  const { data: user, isLoading: isUserLoading } = useCurrentUser()
  const { data: businessesData, isLoading: isBusinessesLoading } = useBusinesses({
    page_size: 1000
  })
  const [selectedBusinessSlug, setSelectedBusinessSlug] = useState<string | undefined>()

  const eligibleBusinesses = useMemo(
    () => getReferralRedeemEligibleBusinesses(businessesData?.results ?? [], user?.userships ?? []),
    [businessesData?.results, user?.userships]
  )

  useEffect(() => {
    setSelectedBusinessSlug(previous =>
      getDefaultReferralRedeemBusinessSlug(eligibleBusinesses, previous ?? contextSlug)
    )
  }, [contextSlug, eligibleBusinesses])

  const selectedBusiness: IBusiness | undefined = eligibleBusinesses.find(
    business => business.slug === selectedBusinessSlug
  )

  return {
    eligibleBusinesses,
    selectedBusiness,
    selectedBusinessSlug,
    setSelectedBusinessSlug,
    isLoading: isUserLoading || isBusinessesLoading
  }
}
